module.exports = __webpack_public_path__ + "img/failed.4f9d6c10.svg";